import usersSlice from "Data/Redux/Slices/User";
import { combineSlices } from "@reduxjs/toolkit";
import partNumbersSlice from "Data/Redux/Slices/PartNumbers";
import uiSlice from "Data/Redux/Slices/Ui";
import itemsSlice from "Data/Redux/Slices/Items";

export const rootReducer = combineSlices(partNumbersSlice, usersSlice, uiSlice, itemsSlice);

export type AppState = ReturnType<typeof rootReducer>;
